import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['dialog', 'fieldset'];

  connect() {
    this.abortController = new AbortController();

    this.dialogTarget.addEventListener('click', (e) => {
      // Firefox sets clientX/Y to 0 when clicking <option> elements,
      // which could trigger unwanted dialog closing.
      //
      // When clicking the backdrop, the browser sets e.target to the
      // <dialog> element itself. By checking node, we ensure the
      // dialog only closes when clicking the dimmed area around it.
      if (e.target !== this.dialogTarget) {
        return;
      }

      const bounds = this.dialogTarget.getBoundingClientRect();

      // Check if click coordinates (clientX/Y) fall within the dialog's bounds.
      // Returns true if the click is inside the dialog's content area,
      // false if it's in the backdrop region.
      const isInDialog = bounds.top <= e.clientY &&
        e.clientY <= bounds.top + bounds.height &&
        bounds.left <= e.clientX &&
        e.clientX <= bounds.left + bounds.width;

      if (!isInDialog) {
        this.close();
      }
    }, { signal: this.abortController.signal });

    this.#toggleFieldset(false);

    if (this.dialogTarget.dataset.opened === 'true') {
      this.open();
    }
  }

  disconnect() {
    this.abortController.abort();
  }

  open() {
    this.#toggleFieldset(true);
    this.dialogTarget.showModal();
  }

  close() {
    this.#toggleFieldset(false);
    this.dialogTarget.close();
  }

  validate() {
    const inputs = this.dialogTarget.querySelectorAll('input, select, textarea');

    for (let i = 0; i < inputs.length; i += 1) {
      if (!inputs[i].reportValidity()) {
        return false;
      }
    }

    return true;
  }

  closeValid() {
    if (this.validate()) {
      this.close();
    }
  }

  #toggleFieldset(enabled) {
    if (this.hasFieldsetTarget) {
      this.fieldsetTarget.disabled = !enabled;
    }
  }
}
